(function(){
	'use strict';

	angular
        .module('app')
        .filter('trustAs', trustAsFilter);

		function trustAsFilter($sce) {
            return function (input, type) {
                if (typeof input === "string") {
                    return $sce.trustAs(type || 'html', input);
                }
                return "";
            };
        }

})();
